module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dof-step-action weex-ct weex-div",
    style: (_vm._px2rem(_vm.style, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.onSubClick($event)
      }
    }
  }, [_vm._t("sub", [(_vm._isColmo) ? _c('dof-iconfont', {
    attrs: {
      "code": '\u4760',
      "size": 64,
      "color": 'rgba(255,255,255,0.80)',
      "data-evt-dofIconFontClicked": ""
    },
    on: {
      "dofIconFontClicked": _vm.onSubClick
    }
  }) : _c('figure', {
    staticClass: " weex-el weex-image",
    style: (_vm._px2rem(_vm.btnStyle, 75)),
    attrs: {
      "src": _vm.icons[_vm._isDiablo ? 'sub_diablo' : 'sub'],
      "data-img-src": _vm.icons[_vm._isDiablo ? 'sub_diablo' : 'sub'],
      "weex-type": "image"
    }
  })], {})], 2), _vm._v(" "), _c('div', {
    staticClass: "dof-step-action-container weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("default", null, {})], 2), _vm._v(" "), _c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.onAddClick($event)
      }
    }
  }, [_vm._t("add", [(_vm._isColmo) ? _c('dof-iconfont', {
    attrs: {
      "code": '\u4705',
      "size": 64,
      "color": 'rgba(255,255,255,0.80)',
      "data-evt-dofIconFontClicked": ""
    },
    on: {
      "dofIconFontClicked": _vm.onAddClick
    }
  }) : _c('figure', {
    staticClass: " weex-el weex-image",
    style: (_vm._px2rem(_vm.btnStyle, 75)),
    attrs: {
      "src": _vm.icons[_vm._isDiablo ? 'add_diablo' : 'add'],
      "data-img-src": _vm.icons[_vm._isDiablo ? 'add_diablo' : 'add'],
      "weex-type": "image"
    }
  })], {})], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-34ee715c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34ee715c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-step-action/index.vue
// module id = 600
// module chunks = 0 1